import { Component, ViewEncapsulation, ViewChild, OnInit, NgZone } from '@angular/core'
import {
  UrlSerializer,
  Router,
  NavigationStart,
  NavigationEnd
} from '@angular/router'
import { Location } from '@angular/common'
import { MergedExceptionHandler, UiExceptionHandler, SentryExceptionHandler, AnalyticsDataProvider } from '@mprep/shared'
import { AppMetricsService } from '@mprep/shared/core/services'
import { DialogComponent } from '@mprep/shared/angular'

import { GoogleAnalytics } from '../../lib/analytics'
import { GTM_ID } from './shared/helpers/constants'

@Component({
  selector: 'mp-app',
  styleUrls: ['./app.scss'],
  template: `<router-outlet></router-outlet>
            <mp-dialog #errors></mp-dialog>
            <mp-popup-notification></mp-popup-notification>`,
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  public title = 'Atlas'

  @ViewChild('errors')
  public errorsDialog: DialogComponent

  constructor(
    private _location: Location,
    private _urlSerializer: UrlSerializer,
    private _router: Router,
    private _appMetricsService: AppMetricsService,
    private _ngZone: NgZone,
    private _mergedExceptionHandler: MergedExceptionHandler,
    private _analyticsDataProvider: AnalyticsDataProvider
  ) {
  }

  public ngOnInit() {
    this._analyticsDataProvider.exposeToWindow()
    this._analyticsDataProvider.set('app', {
      release: RELEASE_VERSION_ID,
      environment: ENVIRONMENT_ID,
      version: APPLICATION_VERSION
    })

    this.replaceRewrittenHashRoute(this._urlSerializer.parse(this._location.path(true)).fragment, this._location)
    this.tryInitializeUiExceptionHandlers(this.errorsDialog)
    this._initializeSentryExceptionHandler()
    this._runGoogleTagManager()
    // this.registerGoogleAnalyticsOnRouteChange(this._router)
    this._router.events
      .filter((event) => event instanceof NavigationStart)
      .subscribe((event: NavigationStart) => {
        this._appMetricsService.logRoute(event.url)
      })
  }

  private replaceRewrittenHashRoute(currentHashFragment: string, location: Location) {
    if (typeof currentHashFragment === 'string' && currentHashFragment.length > 0 && currentHashFragment.startsWith('/')) {
      // removing trailing slash in route that will have been added in routing layer
      location.replaceState(currentHashFragment.replace(/\/($|\?)/, '$1'))
    }
  }

  private tryInitializeUiExceptionHandlers(dialog: DialogComponent) {
    this._mergedExceptionHandler.getAllHandlerInstanceOf<UiExceptionHandler>(UiExceptionHandler)
      .forEach((handler: UiExceptionHandler) => {
        handler.setDialog(dialog)
      })
  }

  private _initializeSentryExceptionHandler() {
    const handler = this._mergedExceptionHandler.getHandlerInstance<SentryExceptionHandler>(SentryExceptionHandler)
    handler.appMetricsService = this._appMetricsService
  }

  // TODO [GitHub Issue]: Move to new component after testing
  private _runGoogleTagManager() {
    this._ngZone.runOutsideAngular(() => {
      (function(w, d, s, l, i) {
        w[l] = w[l] || []
        w[l].push({
            'gtm.start': new Date().getTime(),
            'event': 'gtm.js'
        })
        let f = d.getElementsByTagName(s)[0]
        let j = <HTMLScriptElement> d.createElement(s)
        let dl = l !== 'dataLayer' ? '&l=' + l : ''
        j.async = true
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
        f.parentNode.insertBefore(j, f)
      })(window, document, 'script', 'dataLayer', GTM_ID)
    })
  }

  private registerGoogleAnalyticsOnRouteChange(router: Router) {
   router.events.subscribe((event) => {
     if (event instanceof NavigationEnd && GoogleAnalytics.isActive()) {
       GoogleAnalytics.track(this._location.prepareExternalUrl(event.urlAfterRedirects))
     }
   })
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts